import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=305db253&"
import script from "./FormHeader.vue?vue&type=script&lang=js&"
export * from "./FormHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports